import {Component, Inject, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventsService} from '../../../../../core/services/events.service';

@Component({
  selector: 'add-admin-component',
  templateUrl: './add-admin.component.html',
  styleUrls: ['./add-admin.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule],
  providers: [EventsService]
})

export class AddAdminComponent {

  users = signal<any[]>([]);
  selectedUsers = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<AddAdminComponent>) {
    console.log('data', data);
    if (data) {
      this.users.set(data.users || []);
    }
  }

  addAdmins() {
    this.dialogRef.close(this.selectedUsers);
  }
}
